import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TitleStrategy } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieConsentFeatureModule } from '@shared/cookie-consent';
import { TelespotAuthFeatureModule } from '@telespot/auth/feature';
import { RecorderModule } from '@telespot/shared/session-recorder';
import { TelespotModule } from '@telespot/web-core';
import { environment } from '@telespot/shared/environment';
import { TelespotShellModule } from '@telespot/shell';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ThanksComponent } from './components/thanks/thanks.component';
import { SharedModule } from './shared/shared.module';
import { PageNotAuthorizedComponent } from './components/page-not-authorized/page-not-authorized.component';
import { provideRecorderIdentity } from './recorder-identity';
import { provideAdminOnlyDenials } from './recorder-denial-policy';
import { RouteDataTitleStrategy } from './route-data-title.strategy';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/');
}

@NgModule({
  imports: [
    SharedModule,
    TelespotShellModule,
    BrowserModule,
    BrowserAnimationsModule,
    TelespotModule.forRoot({
      environment: environment,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      useDefaultLang: true,
    }),
    TelespotAuthFeatureModule,
    AppRoutingModule,
    StoreRouterConnectingModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.serviceWorker }),
    StoreModule.forRoot({
      router: routerReducer,
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      connectInZone: true,
    }),
    EffectsModule.forRoot(),
    CookieConsentFeatureModule,
    RecorderModule,
  ],
  declarations: [AppComponent, PageNotFoundComponent, ThanksComponent, PageNotAuthorizedComponent],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true },
    },
    { provide: TitleStrategy, useClass: RouteDataTitleStrategy },
    provideRecorderIdentity(),
    provideAdminOnlyDenials(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
